/* eslint-disable */
import orm from "./models";
import uuid from "uuid";

function init(orm) {
  const state = orm.getEmptyState();
  const session = orm.mutableSession(state);
  session.Settings.create({
    id: 0,
    username: "",
    password: "",
    error: "",
    calls: 0,
    token: "",
    isFullScreen: false
  });

  // status.map(item => session.RX_Status.create(item));
  // severity.map(item => session.RX_Severity.create(item));
  // boards.map(item => session.RX_Board.create(item));
  // reports.map(item => session.RX_Report.create(item));
  // alerts.map(item => session.RX_Alert.create(item));
  // teams.map(item => session.RX_Team.create(item));
  // users.map(item => session.RX_User.create(item));
  // page_config.map(item => session.RX_Page_Config.create(item));
  // charts.map(item => session.RX_Chart.create(item));
  // chart_previews.map(item => session.RX_Chart_Preview.create(item));

  return state;
}

export function rootReducer(dbState = init(orm), action) {
  const session = orm.session(dbState);

  // Session-specific Models are available
  // as properties on the Session instance.
  const model = action.payload ? action.payload.model : "";
  const payload = action.payload ? action.payload.payload : "";
  switch (action.type) {
    case "ORM_CREATE":
      session[model].create({
        id: uuid.v1(),
        ...payload
      });
      break;
    case "ORM_UPSERT":
      session[model].upsert(payload);
      break;
    case "ORM_REMOVE":
      if (session[model].hasId(payload.id))
        session[model].withId(payload.id).delete();
      break;
    case "ORM_ADD_TO":
      if (session[model].hasId(payload.id))
        session[model].withId(payload.id)[payload.item].add(payload.value);
      break;
    case "ORM_REMOVE_FROM":
      if (session[model].hasId(payload.id))
        session[model].withId(payload.id)[payload.item].remove(payload.value);
      break;
    case "FETCH_REQUEST":
      session.Settings.upsert(action.payload);
      session.Settings.withId(action.payload.id).update({
        calls: session.Settings.withId(action.payload.id).calls
          ? session.Settings.withId(action.payload.id).calls + 1
          : 1
      });
      break;
    case "FETCH_SUCCESS":
      session.Settings.withId(action.payload.id).update({
        calls: session.Settings.withId(action.payload.id).calls - 1
      });
      break;
    case "FETCH_FAILURE":
      session.Settings.withId(action.payload.id).update({
        calls: session.Settings.withId(action.payload.id).calls - 1,
        error: action.payload.error
      });
      break;
    case "NOOP":
    default:
      break;
  }

  // the state property of Session always points to the current database.
  // Updates don't mutate the original state, so this reference is not
  // equal to `dbState` that was an argument to this reducer.
  return session.state;
}



// WEBPACK FOOTER //
// ./src/reducers.js